<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("lbl.pelletizing.qualityResult.selfTestPelletizingGriList") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd">
              <span>{{$t('tlt.pelletizing')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/selfTestPelletizing">
              <span>{{$t('tlt.pelletizing.selfTestPelletizing')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
              <router-link :to="{path:'/prd/selfTestPelletizingGri', query:{id: selfTestId}}">
              <span>{{$t('tlt.pelletizing.selfTestPelletizingGri')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/selfTestPelletizingGri/edit">
              <span>{{$t('tlt.pelletizing.selfTestPelletizingGri.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="BackToList()"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <button class="btn btn-primary" type="button" v-on:click="Save()">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.shiftPlanNum')}}:
                </label>
                <input
                  disabled="disabled"
                  v-validate="'required'"
                  name="selfTestCode"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('selfTestCode') }"
                  v-model="selfTestCode"
                  type="text"
                />
                <span
                  v-show="errors.has('selfTestCode')"
                  class="lbl-obg"
                >{{ errors.first('selfTestCode') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.analysisTime')}}：
                </label>
                <mmf-datepicker disabled="disabled" v-model="analysisTime"></mmf-datepicker>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.residue1')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="residue1"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('residue1') }"
                  v-model="residue1"
                  type="text"
                />
                <span v-show="errors.has('residue1')" class="lbl-obg">{{ errors.first('residue1') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.residue2')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="residue2"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('residue2') }"
                  v-model="residue2"
                  type="text"
                />
                <span v-show="errors.has('residue2')" class="lbl-obg">{{ errors.first('residue2') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.residue3')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="residue3"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('residue3') }"
                  v-model="residue3"
                  type="text"
                />
                <span v-show="errors.has('residue3')" class="lbl-obg">{{ errors.first('residue3') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.granularity1')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="granularity1"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('granularity1') }"
                  v-model="granularity1"
                  type="text"
                />
                <span
                  v-show="errors.has('granularity1')"
                  class="lbl-obg"
                >{{ errors.first('granularity1') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.granularity2')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="granularity2"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('granularity2') }"
                  v-model="granularity2"
                  type="text"
                />
                <span
                  v-show="errors.has('granularity2')"
                  class="lbl-obg"
                >{{ errors.first('granularity2') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.granularity3')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="granularity3"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('granularity3') }"
                  v-model="granularity3"
                  type="text"
                />
                <span
                  v-show="errors.has('granularity3')"
                  class="lbl-obg"
                >{{ errors.first('granularity3') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.granularity4')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="granularity4"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('granularity4') }"
                  v-model="granularity4"
                  type="text"
                />
                <span
                  v-show="errors.has('granularity4')"
                  class="lbl-obg"
                >{{ errors.first('granularity4') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.concentration')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="concentration"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('concentration') }"
                  v-model="concentration"
                  type="text"
                />
                <span
                  v-show="errors.has('concentration')"
                  class="lbl-obg"
                >{{ errors.first('concentration') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingGri.checkUser')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="checkUser"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('checkUser') }"
                  v-model="checkUser"
                  type="text"
                />
                <span
                  v-show="errors.has('checkUser')"
                  class="lbl-obg"
                >{{ errors.first('checkUser') }}</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 260px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { fields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingGri";
import MmfDatepicker from "@/components/MmfDatepicker";
// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "selfTestPelletizingGri/getField",
  mutationType: "selfTestPelletizingGri/updateField"
});

export default {
  name: "selfTestPelletizingGriEdit",
  data() {
    return {};
  },

  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapState({
      rows: state => state.selfTestPelletizingGri.rows,

      entity: state => state.selfTestPelletizingGri.entity,

      selfTestId: state => state.selfTestPelletizingGri.selfTestId
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList"]),
    ...mapActions("selfTestPelletizingGri", ["Save","BackToList"])
  },
  components: {
    MmfDatepicker
  }
};
</script>
